import { ContentType } from '../models/content-type.enum';

export function storyType(storyId: string): ContentType {
  return (storyId.split('/').length > 1) ? ContentType.Module : ContentType.Bookmark;
}
